import { useNavigate } from 'react-router-dom';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { Box, Container, Typography } from '@mui/material';
import { ActionButton } from '@core/components';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 8,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '6rem', md: '8rem' },
            fontWeight: 700,
            color: 'primary.main',
            mb: 2,
            lineHeight: 1,
          }}
        >
          404
        </Typography>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            mb: 2,
            color: 'text.primary',
          }}
        >
          Page Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '1.125rem',
            color: 'text.secondary',
            mb: 4,
            maxWidth: 500,
          }}
        >
          The page you're looking for doesn't exist or has been moved. Let's get
          you back on track.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
          }}
        >
          <ActionButton
            variant="primary"
            size="lg"
            icon={<HomeIcon />}
            iconPosition="start"
            onClick={handleGoHome}
          >
            Go to Dashboard
          </ActionButton>

          <ActionButton
            variant="outline"
            size="lg"
            icon={<ArrowBackIcon />}
            iconPosition="start"
            onClick={handleGoBack}
          >
            Go Back
          </ActionButton>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
